module.exports = __webpack_public_path__ + "static/img/two.7040e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/2/two.png
// module id = Srhw
// module chunks = 1